<template>
<div>
  <div class="empty-stage-background">
    <div class="empty-stage-container">
      <div class="empty-stage-message">
        <div class="empty-stage-image"
        :style="{ backgroundImage: 'url(' + require('@common/asset/images/'+icon+'.svg') + ')' }"
        ></div>
        <div
        class="empty-stage-text"
        v-html="text"
        >
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    icon: String,
    text: String,
  },

};
</script>
<style lang='scss'>
.empty-stage{
  &-background {
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    top: 170px;
    left: 0;
    right: 100%;
    bottom: 100%;
    width: 100%;
    height: 100%;
  }
  &-container {
    position: absolute;
    left: 50%;
    top: 28%;
  }
  &-message{
    margin-left: auto;
    margin-right: auto;
    opacity: 0.94;
    position: relative;
    left: -50%;
  }
  &-image{
    width: 200px;
    height:200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    background-repeat: no-repeat;
    left: 0px;
    top: 0px;
    background-size: contain;
  }
  &-text{
    color: #234357;
    text-align: center;
    font-size: 1.6rem;
    letter-spacing: 0.64px;
    padding: 10px 0px;
    font-style: italic;
  }
}
</style>
